var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScreenMotto'),_c('ScreenAbout'),_c('ScreenDigits'),_c('ScreenBanner'),_c('ScreenServices'),_c('ScreenPortfolio'),_c('ScreenTech'),_c('ScreenContacts'),_c('contact-modal-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }